import tipsList from "../common/constants/tipsList";
import Tips from "./Tips";
import React, { useState, useEffect } from "react";
import truckyApiClientService from "../common/services/truckyapi-client-service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import CustomBadge from "./ui/CustomBadge";
import { useNavigate } from "react-router";
import EnterpriseService from "../common/services/enterprise-service";
import Paginator from "./ui/Paginator";
import { Link } from "react-router-dom";

import BoxDynamicAd from "../ads/BoxDynamicAd";
import truckyService from "../common/services/trucky-service";
import LazyImage from "../web/components/common/LazyImage";
import TimeZoneData from "./TimeZoneData";

const LeaderboardsV2 = ({ container }) => {
  const navigate = useNavigate();
  const es = new EnterpriseService();
  const [filters, setFilters] = useState({
    period: "monthly",
    game: "",
    name: "",
    country: "",
  });
  const [loading, setLoading] = useState(true);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    truckyService.setDocumentTitle("User Leaderboards");
  }, []);

  useEffect(() => {
    getLeaderboardData();
  }, [pagination, filters.period]);

  const search = async () => {
    setPagination({ ...pagination, page: 1 });
  };

  const getLeaderboardData = async () => {
    setLoading(true);
    const result = await es.getUsersLeaderboards(filters, pagination);
    setLeaderboardData(result.data);
    setTotalPages(result.last_page);
    setLoading(false);
  };

  const handlePageClick = (event) => {
    setPagination({ ...pagination, page: event.selected + 1 });
  };

  const changeTab = (tab) => {
    setPagination({ ...pagination, page: 1 });
    setFilters({ ...filters, period: tab });
  };

  const handleRowsPerPageChange = (perPage) => {
    setPagination({ ...pagination, page: 1, perPage: perPage });
  };
  
  return (
    <div>
      <div className="page-hero">
        <span className="page-hero-icon">
          <FontAwesomeIcon icon="users" className="mx-0"></FontAwesomeIcon>
        </span>
        <div>
          <h1 className="page-hero-title">
            {container.localeManager.strings.leaderboards}
          </h1>
        </div>
      </div>
      <LoadingOverlay
      active={loading}
      spinner={
        <Spinner
          color="primary"
          style={{ width: "4rem", height: "4rem" }}
        ></Spinner>
      }
    >
      <Row noGutters>
        <Col>
          <Card>
            <CardBody>
              <div className="filters-toolbar mb-3">
                <Row>
                  <Col sm="6">
                    <FormGroup>
                      <Label>{container.localeManager.strings.username}</Label>
                      <Input
                        placeholder={
                          container.localeManager.strings.searchForPlayerName
                        }
                        value={filters.name}
                        type="text"
                        onChange={(e) =>
                          setFilters({ ...filters, name: e.target.value })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label>{container.localeManager.strings.country}</Label>
                      <Input
                        placeholder={
                          container.localeManager.strings.country2DigitsCode
                        }
                        value={filters.country}
                        type="text"
                        onChange={(e) =>
                          setFilters({ ...filters, country: e.target.value })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end">
                    <Button size="sm" color="primary" onClick={() => search()}>
                      {container.localeManager.strings.searchButton}
                    </Button>
                  </Col>
                </Row>
              </div>
              {leaderboardData != null && leaderboardData.length > 0 && (
                <>
                  <Paginator
                    rowsPerPageSelected={pagination.perPage}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    showRowsPerPage={true}
                    forcePage={pagination.page - 1}
                    totalPages={totalPages}
                    handlePageClick={handlePageClick}
                  />
                  <Table
                    responsive
                    striped
                    size="sm"
                    className="table-row-dashed table-row-gray-300 align-middle gs-0 leaderboards mt-3"
                    hover
                  >
                    <thead>
                      <tr className="fw-bolder text-gray-700 bg-light">
                        <th className="text-center">#</th>
                        <th className="text-start">
                          {container.localeManager.strings.driver}
                        </th>
                        <th className="text-start">
                          {container.localeManager.strings.company}
                        </th>
                        <th className="text-center">
                          {container.localeManager.strings.country}
                        </th>
                        <th className="text-center">
                          {container.localeManager.strings.level}
                        </th>
                        <th className="text-center">
                          {container.localeManager.strings.points}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaderboardData.map((m) => {
                        return (
                          <tr>
                            <td class="text-center">
                              <span className="ranking">{m.position}</span>
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <div>
                                  <img
                                    className="avatar h-50px min-w-50px rounded me-3"
                                    src={m.avatar_url}
                                  />
                                </div>
                                <div>
                                  <Link to={`/user/${m.user_id}`}>
                                    {m.name}
                                  </Link>
                                </div>
                              </div>
                            </td>
                            <td className="text-center">
                              {m.company != null && (
                                <div class="d-flex align-items-center">
                                  <div>
                                    <LazyImage src={m.company.avatar_url} className="avatar h-50px min-w-50px rounded me-3" placeholder="/assets/company-placeholder.png" />
                                  </div>
                                  <div>
                                    <Link to={`/company/${m.company.id}`}>
                                      {m.company.name}
                                    </Link>
                                  </div>
                                </div>
                              )}
                            </td>
                            <td className="text-center">
                              {m.country != undefined && m.country != "" && (
                                <img
                                  src={
                                    "https://flagcdn.com/w40/" +
                                    m.country.toLowerCase() +
                                    ".png"
                                  }
                                />
                              )}
                            </td>
                            <td className="text-center">
                              <CustomBadge color="primary" className="level">
                                {m.level}
                              </CustomBadge>
                            </td>
                            <td className="text-center">
                              <span className="points">
                                {container.localeManager
                                  .numeral(m.points)
                                  .format(0, 0)}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <Paginator
                   rowsPerPageSelected={pagination.perPage}
                   handleRowsPerPageChange={handleRowsPerPageChange}
                   showRowsPerPage={true}

                    forcePage={pagination.page - 1}
                    totalPages={totalPages}
                    handlePageClick={handlePageClick}
                  />
                  <TimeZoneData container={container}></TimeZoneData>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
        <div className="ad-column-placeholder">
          <Tips
            tipKey={tipsList.KEYS.LEADERBOARDS}
            localeManager={container.localeManager}
          ></Tips>
          {!container.dataService.data.enablePremiumFeature() && (
            <BoxDynamicAd container={container} className="my-3" />
          )}
        </div>
      </Row>
    </LoadingOverlay>
    </div>
  );
};

export default LeaderboardsV2;
